const $ = jQuery;

$(document).ready(function () {
	if (parseInt(ajax_object.is_buy_now_enabled) !== 1) {
		return;
	}

	$.ajax({
		url: ajax_object.ajax_url,
		type: 'post',
		data: {
			action: 'cbd_get_buy_now_bar',
		},
		dataType: 'json',
		success: function(response) {
			if (response.data.expires && response.data.expires > 0) {
				$('.buy-now-bar .buy-now-bar-text').html(response.data.text);
				if (response.data.button_text && response.data.button_url) {
					$('.buy-now-bar .buy-now-bar-button').html('<a class="btn" href="' + response.data.button_url + '">' + response.data.button_text + '</a>');
				}

				const timestamp = response.data.expires * 1000;
				$('.buy-now-bar .buy-now-bar-timer').countdown(timestamp, function(e) {
					if (e.elapsed) {
						$(this).html('<p>Expired!</p>');
					} else {
						$(this).html(e.strftime('<p>Expires in <span>%M</span> min <span>%S</span> sec</p>'));
					}
				});

				let timeout = (response.data.start * 1000) - Date.now();
				if (timeout < 0) {
					timeout = 0;
				}
				setTimeout(function() {
					$('.buy-now-bar').slideDown();
				}, timeout)
			}
		},
	});

	$('.buy-now-bar').on('click', 'a.close', function(e) {
		e.preventDefault();
		$('.buy-now-bar').slideUp();
		$.ajax({
			url: ajax_object.ajax_url,
			type: 'post',
			data: {
				action: 'cbd_hide_buy_now_bar',
			},
			dataType: 'json',
		});
	});

});



// WEBPACK FOOTER //
// ./src/js/buy-now.js